import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { STATUS_ORCAMENTO_OPCOES } from "./StatusBadge";

/** Seletor rápido de status do orçamento (funil de vendas). */
export const StatusSelect = ({
  value,
  onValueChange,
  className = "h-9 w-[168px]",
  testid,
}) => (
  <Select value={value || "ENVIADO"} onValueChange={onValueChange}>
    <SelectTrigger className={`text-[12.5px] ${className}`} data-testid={testid}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="bg-white">
      {STATUS_ORCAMENTO_OPCOES.map((o) => (
        <SelectItem key={o.codigo} value={o.codigo}>
          {o.nome}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
